export default "__VITE_ASSET__rP9mfaZ___"